
export const STATUS_OK = 200;

export const TIMEOUT = 300000;

export const STATUS = 'status'; // 后台返回的状态码，如 code status 这些

// 客户端身份标识，一般不需要修改
export const clientId = '1b2f3298686d4dfdbb1dc845fe1d00d4'
export const clientSecret = 'yVbe3AcXSSECaV5SUhBIs7Vh5pC3krIQkDL'
export const PublicKey = '040ECAE82EA6BDC5FF6C90E6D8700F4F9BD44224E8F7F7576FA9B17CE823C18DD5C1D4F9CBF4EE23B3D3347C589036EE13E9497607D0F6C7B5CC655D0D250EDCE8'

export const baseURL = {
    dev: '/api',
    // prod: 'https://testpm.cscecxn.com/api', //  uat环境https
    // prod: 'http://testpm.cscecxn.com:18000', // uat环境
    // prod: 'http://pm.cscecxn.com:18000', //正式环境
    // prod: 'http://zuul.zj8j.cdtest.cddpi.com', //测试环境
    prod: 'http://mzuul.zj8j.cddev.cddpi.com',//开发环境
};
// export const ImgBaseURL =  process.env.NODE_ENV === 'development' ? baseURL.dev  : baseURL.prod;
export const ImgBaseURL =  process.env.NODE_ENV === 'development' ? baseURL.dev  : process.env.VUE_APP_baseURL;
export const DevelopmentURL =baseURL.prod;
export const DownLoadFileURL = process.env.VUE_APP_auditUrl;
export const statusCodeMsg = [{
        code: 401,
        msg: '未授权,请重新登录'
    },
    {
        code: 403,
        msg: '拒绝访问'
    }
];
/**
 * @description token在Cookie中存储的天数，默认1天
 */
export const cookieExpires = 1;


